import { tiposEn, tiposEs, tiposPt } from './relatorio-tipos-i18n';
/** Lote crm5 (E4): textos do relatório do CRM (o "Dashboard" da origem), em `crm.relatorio`. */
export const relatorioPt = {
  titulo: 'Relatórios',
  subtitulo: 'Dashboard das negociações do funil no período',
  funil: 'Funil de vendas',
  responsavel: 'Responsável',
  todas: 'Todas as negociações',
  minhas: 'Minhas negociações',
  recarregar: 'Recarregar',
  recarregado: 'Relatório recarregado',
  filtros: 'Filtros ({{n}})',
  filtrosTitulo: 'Filtros',
  filtrosAtivos_one: 'Você tem {{count}} filtro ativo',
  filtrosAtivos_other: 'Você tem {{count}} filtros ativos',
  data: 'Data',
  de: 'De',
  ate: 'Até',
  periodo: '{{de}} a {{ate}}',
  campanha: 'Campanha',
  fonte: 'Fonte',
  produto: 'Produto ou serviço',
  todasOpcoes: 'Todas',
  todosProdutos: 'Todos',
  cancelar: 'Cancelar',
  limpar: 'Limpar filtros',
  aplicar: 'Aplicar filtros',
  periodoInvalido: 'O fim do período vem antes do início',
  tirar: 'Tirar o filtro {{nome}}',
  filtrosLigados: 'Filtros ligados',
  exportar: 'Exportar {{bloco}} em CSV',
  exportado: 'Relatório exportado',
  carregando: 'Carregando o relatório...',
  erro: 'Não foi possível carregar o relatório',
  item: 'Item',
  quantidade: 'Quantidade',
  tipos: tiposPt,
  blocos: {
    resumo: 'Resumo',
    valorVolume: 'Valor x Volume',
    tarefas: 'Tarefas',
    atualizacoes: 'Atualizações gerais',
    entradas: 'Entradas nos estágios',
    perdidas: 'Negociações perdidas',
  },
  resumo: {
    criadas: 'Negociações criadas',
    vendas: 'Vendas',
    perdidas: 'Negociações perdidas',
    sem_proxima_tarefa: 'Sem próx. tarefa',
    sem_interacoes: 'Sem interações',
    recem_alocadas: 'Recém alocadas',
  },
  valorTipo: 'Tipo de valor',
  valores: {
    total: 'Valor total',
    unico: 'Valor único',
    recorrente: 'Valor recorrente',
  },
  valor: 'Valor',
  unidades: 'Unidades',
  ticket: 'Ticket médio',
  colunasTarefas: {
    criadas: 'Tarefas criadas',
    pendentes: 'Tarefas pendentes',
    finalizadas: 'Tarefas finalizadas',
  },
  total: 'Total',
  coluna: 'Coluna',
  tipo: 'Tipo',
  anotacoes: 'Anotações',
  emails: 'E-mails enviados',
  estrelas_one: '{{count}} estrela',
  estrelas_other: '{{count}} estrelas',
  etapa: 'Etapa',
  valoresPerdidos: 'Valores perdidos',
  perdidoUnico: 'Valor perdido único',
  perdidoRecorrente: 'Valor perdido recorrente',
  perdidoTotal: 'Valor perdido total',
  motivos: 'Motivos de perda',
  semMotivo: 'Sem motivo',
  semPerdidas: 'Não houve negociações perdidas nos filtros selecionados!',
  semEtapas: 'O funil não tem etapas abertas.',
  arquivo: 'relatorio-{{bloco}}.csv',
};

export const relatorioEn: typeof relatorioPt = {
  titulo: 'Reports',
  subtitulo: 'Dashboard of the pipeline deals in the period',
  funil: 'Sales pipeline',
  responsavel: 'Owner',
  todas: 'All deals',
  minhas: 'My deals',
  recarregar: 'Reload',
  recarregado: 'Report reloaded',
  filtros: 'Filters ({{n}})',
  filtrosTitulo: 'Filters',
  filtrosAtivos_one: 'You have {{count}} active filter',
  filtrosAtivos_other: 'You have {{count}} active filters',
  data: 'Date',
  de: 'From',
  ate: 'To',
  periodo: '{{de}} to {{ate}}',
  campanha: 'Campaign',
  fonte: 'Source',
  produto: 'Product or service',
  todasOpcoes: 'All',
  todosProdutos: 'All',
  cancelar: 'Cancel',
  limpar: 'Clear filters',
  aplicar: 'Apply filters',
  periodoInvalido: 'The end of the period comes before the start',
  tirar: 'Remove the {{nome}} filter',
  filtrosLigados: 'Active filters',
  exportar: 'Export {{bloco}} as CSV',
  exportado: 'Report exported',
  carregando: 'Loading the report...',
  erro: 'Could not load the report',
  item: 'Item',
  quantidade: 'Quantity',
  tipos: tiposEn,
  blocos: {
    resumo: 'Summary',
    valorVolume: 'Value x Volume',
    tarefas: 'Tasks',
    atualizacoes: 'General updates',
    entradas: 'Stage entries',
    perdidas: 'Lost deals',
  },
  resumo: {
    criadas: 'Deals created',
    vendas: 'Sales',
    perdidas: 'Lost deals',
    sem_proxima_tarefa: 'No next task',
    sem_interacoes: 'No interactions',
    recem_alocadas: 'Recently assigned',
  },
  valorTipo: 'Value type',
  valores: {
    total: 'Total value',
    unico: 'One-time value',
    recorrente: 'Recurring value',
  },
  valor: 'Value',
  unidades: 'Units',
  ticket: 'Average ticket',
  colunasTarefas: {
    criadas: 'Tasks created',
    pendentes: 'Pending tasks',
    finalizadas: 'Finished tasks',
  },
  total: 'Total',
  coluna: 'Column',
  tipo: 'Type',
  anotacoes: 'Notes',
  emails: 'E-mails sent',
  estrelas_one: '{{count}} star',
  estrelas_other: '{{count}} stars',
  etapa: 'Stage',
  valoresPerdidos: 'Lost values',
  perdidoUnico: 'One-time value lost',
  perdidoRecorrente: 'Recurring value lost',
  perdidoTotal: 'Total value lost',
  motivos: 'Loss reasons',
  semMotivo: 'No reason',
  semPerdidas: 'No deals were lost with the selected filters!',
  semEtapas: 'The pipeline has no open stages.',
  arquivo: 'report-{{bloco}}.csv',
};

export const relatorioEs: typeof relatorioPt = {
  titulo: 'Informes',
  subtitulo: 'Panel de las negociaciones del embudo en el período',
  funil: 'Embudo de ventas',
  responsavel: 'Responsable',
  todas: 'Todas las negociaciones',
  minhas: 'Mis negociaciones',
  recarregar: 'Recargar',
  recarregado: 'Informe recargado',
  filtros: 'Filtros ({{n}})',
  filtrosTitulo: 'Filtros',
  filtrosAtivos_one: 'Tienes {{count}} filtro activo',
  filtrosAtivos_other: 'Tienes {{count}} filtros activos',
  data: 'Fecha',
  de: 'Desde',
  ate: 'Hasta',
  periodo: '{{de}} a {{ate}}',
  campanha: 'Campaña',
  fonte: 'Fuente',
  produto: 'Producto o servicio',
  todasOpcoes: 'Todas',
  todosProdutos: 'Todos',
  cancelar: 'Cancelar',
  limpar: 'Limpiar filtros',
  aplicar: 'Aplicar filtros',
  periodoInvalido: 'El fin del período es anterior al inicio',
  tirar: 'Quitar el filtro {{nome}}',
  filtrosLigados: 'Filtros activos',
  exportar: 'Exportar {{bloco}} en CSV',
  exportado: 'Informe exportado',
  carregando: 'Cargando el informe...',
  erro: 'No se pudo cargar el informe',
  item: 'Ítem',
  quantidade: 'Cantidad',
  tipos: tiposEs,
  blocos: {
    resumo: 'Resumen',
    valorVolume: 'Valor x Volumen',
    tarefas: 'Tareas',
    atualizacoes: 'Actualizaciones generales',
    entradas: 'Entradas en las etapas',
    perdidas: 'Negociaciones perdidas',
  },
  resumo: {
    criadas: 'Negociaciones creadas',
    vendas: 'Ventas',
    perdidas: 'Negociaciones perdidas',
    sem_proxima_tarefa: 'Sin próx. tarea',
    sem_interacoes: 'Sin interacciones',
    recem_alocadas: 'Recién asignadas',
  },
  valorTipo: 'Tipo de valor',
  valores: {
    total: 'Valor total',
    unico: 'Valor único',
    recorrente: 'Valor recurrente',
  },
  valor: 'Valor',
  unidades: 'Unidades',
  ticket: 'Ticket medio',
  colunasTarefas: {
    criadas: 'Tareas creadas',
    pendentes: 'Tareas pendientes',
    finalizadas: 'Tareas finalizadas',
  },
  total: 'Total',
  coluna: 'Columna',
  tipo: 'Tipo',
  anotacoes: 'Notas',
  emails: 'Correos enviados',
  estrelas_one: '{{count}} estrella',
  estrelas_other: '{{count}} estrellas',
  etapa: 'Etapa',
  valoresPerdidos: 'Valores perdidos',
  perdidoUnico: 'Valor perdido único',
  perdidoRecorrente: 'Valor perdido recurrente',
  perdidoTotal: 'Valor perdido total',
  motivos: 'Motivos de pérdida',
  semMotivo: 'Sin motivo',
  semPerdidas: '¡No hubo negociaciones perdidas con los filtros seleccionados!',
  semEtapas: 'El embudo no tiene etapas abiertas.',
  arquivo: 'informe-{{bloco}}.csv',
};
